module.exports = __webpack_public_path__ + "img/icon-2-2.322a345d.png";